import { ComponentsOverrides, ComponentsProps, Theme } from '@mui/material';
import { FontFamilies, FontWeights } from 'shared';

export const getMuiTabsOverrides = (theme: Theme): ComponentsOverrides['MuiTabs'] => ({
  root: {
    '.MuiTab-root': {
      marginLeft: theme.spacing(2),

      '&:first-of-type': {
        marginLeft: 0,
      },
    },
  },
  indicator: {
    display: 'none',
  },
});

export const getMuiTabOverrides = (theme: Theme): ComponentsOverrides['MuiTab'] => ({
  root: {
    color: theme.themeColors.colorTabs,
    background: theme.themeColors.colorTabsBackground,
    border: `2px solid ${theme.themeColors.colorTabsBackground}`,
    textTransform: 'capitalize',
    fontWeight: FontWeights.Regular,
    fontFamily: FontFamilies.secondary,
    fontSize: '16px',
    padding: theme.spacing(1, 2.5, 1, 1),
    iconPosition: 'start',
    minHeight: 38,
    borderRadius: '129px',
    svg: {
      marginRight: 12,
    },

    '&.Mui-selected': {
      color: theme.themeColors.colorTabsActive,
      background: theme.themeColors.colorTabsBackground,
      border: `2px solid ${theme.themeColors.colorTabsBorderActive}`,
      fontWeight: FontWeights.Bold,
    },
  },
});

export const getMuiTabDefaultProps = (): ComponentsProps['MuiTab'] => ({
  disableRipple: true,
  iconPosition: 'start',
});
